import * as constants from './constants';
import { loginSlice } from './slice';

export default { constants, loginSlice };
